module.exports = __webpack_public_path__ + "img/settings-inactive-icon.7a15eb53.svg";